import { useContext } from 'react';

import NewsCard from '@/components/game/ui/card/NewsCard';
import { GameContext } from '@/state/contexts';
import '@/style/HandModal.css';

const NewsCardsModal = ({ onClose }) => {
	const { seasonalNewsCards } = useContext(GameContext);

	if (seasonalNewsCards == null || seasonalNewsCards.length === 0) {
		return;
	}

	function cardNewsGenerator(cardId) {
		return (
			<div className="card" key={cardId}>
				<NewsCard cardId={cardId} width={0} height={0} />
			</div>
		);
	}

	return (
		<div className="modal" onClick={onClose}>
			<div className="modal-content" onClick={(e) => e.stopPropagation()}>
				<span className="close" onClick={onClose}>
					&times;
				</span>
				<h2 className="modal-title">The News This Season</h2>

				<div className="hand">
					{seasonalNewsCards.map((cardId) =>
						cardNewsGenerator(cardId)
					)}
				</div>
			</div>
		</div>
	);
};

export default NewsCardsModal;
